import React from "react"
import { ButtonBase, ButtonProps } from "./ButtonBase"

export const ButtonTransparent = ({ className, ...props }: ButtonProps) => {
  return (
    <ButtonBase
      className={`text-textPrimary bg-transparent hover:bg-whiteHover disabled:hover:bg-transparent ${className}`}
      {...props}
    />
  )
}
